module.exports = function (req, res, next) {
    res.setHeader('Cache-Control', 'max-age=1800');
    res.setHeader('Content-Security-Policy', "frame-ancestors 'none';");
    res.setHeader('X-Frame-Options','DENY');
    res.setHeader('X-Content-Type-Options','nosniff');
    res.setHeader('Strict-Transport-Security','max-age=15552000; includeSubDomains');
    next();
}